module.exports = __webpack_public_path__ + "img/img-skin05.dc811205.jpg";